import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close-dialog",
  "use": "icon-close-dialog-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close-dialog\">\n<circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"black\" fill-opacity=\"0.2\" />\n<circle cx=\"18\" cy=\"18\" r=\"17\" stroke=\"white\" stroke-opacity=\"0.5\" stroke-width=\"2\" />\n<path opacity=\"0.8\" d=\"M24.5 12.5L12.5 24.5M12.5 12.5L24 24.5\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close-dialog.svg
// module id = KbMm
// module chunks = 6 7